import { colors, screen } from 'components/styles/variables';
import { ReactNode } from 'react';
import classNames from 'classnames';

function DetailCell({
  className,
  topInfo,
  bottomInfo,
  isRightCell = false,
  dataTestId,
}: {
  className?: string;
  topInfo: ReactNode;
  bottomInfo: ReactNode;
  isRightCell?: boolean;
  dataTestId?: string;
}): JSX.Element {
  return (
    <div
      className={classNames(className, 'detail-cell-container', { 'right-cell': isRightCell })}
      data-testid={dataTestId}
    >
      <span className="detail-cell-top-info" data-testid="top">
        {topInfo}
      </span>
      <span className="detail-cell-bottom-info" data-testid="bottom">
        {bottomInfo}
      </span>
      <style jsx>{`
        .detail-cell-container {
          display: flex;
          flex-direction: column;
          flex-basis: 60%;
        }

        .detail-cell-top-info {
          font-weight: bold;
          font-size: 24px;
          line-height: 1.36;
          letter-spacing: 0.29px;
          color: ${colors.BLACK};
          margin-bottom: 7px;
        }

        @media (max-width: ${screen.xsMax}) {
          .detail-cell-top-info {
            font-size: 18px;
            line-height: 1.38;
            letter-spacing: 0.21px;
            margin-bottom: 5px;
          }
        }

        .detail-cell-bottom-info {
          font-size: 14px;
          color: ${colors.G3};
          letter-spacing: 0.2px;
        }

        @media (min-width: ${screen.smMin}) {
          .detail-cell-bottom-info {
            font-size: 18px;
            letter-spacing: 0.2px;
          }
        }

        .detail-cell-container.right-cell {
          flex-basis: 35%;
          flex-grow: 1;
          align-items: flex-end;
        }
      `}</style>
    </div>
  );
}

export default DetailCell;
